export default "__VITE_ASSET__wCYZKvgz__"